<template>
    <div class="departments__inner">
        <div class="departments__header">
            <div class="departments__search">
                <LocationSearch @locationSearchApiSubmit="handleLocationSearchApiSubmitEvent" :useAPI="true"
                    :showLocationButton="false" />
            </div>
            <div class="departments__cta" v-html="dictionary.PriceFinderDepartmentsHeaderCtaText"></div>
        </div>
        <div class="departments__columns">
            <div class="departments__column">
                <div v-if="departments.length > 0"
                    class="departments__cards departments__cards--no-bottom-margin departments__cards--hidden-cards">
                    <DepartmentCard v-for="department in departments" :key="department.Id" :department="department"
                        @departmentSelect="handleDepartmentSelect" />
                    <a v-if="departments.length < totalDepartments" v-on:click="getNextPage"
                        class="storage-calculator__departments-load-more">Indlæs flere</a>
                </div>
            </div>
            <div class="departments__column room-price-table__wrap">
                <div class="room-price-table" v-if="selectedDepartment != null">
                    <p class="room-price-table__headline">{{ selectedDepartment.City }} - {{
                        selectedDepartment.Address
                    }}
                    </p>

                    <RoomSizeSlider :departmentId="selectedDepartment.Id" initialSize="2"
                        :minimum="selectedDepartment.MinSqm" :maximum="selectedDepartment.MaxSqm" :unit="'area'"
                        @sliderChanged="handleRangeSlideChange" />
                    <table class="room-price-table__table">
                        <thead>
                            <tr>
                                <th>{{ dictionary.PriceFinderRoomTableSize }}</th>
                                <th>{{ dictionary.PriceFinderRoomTableVolume }}</th>
                                <th>{{ dictionary.PriceFinderRoomTablePrice }}</th>
                            </tr>
                        </thead>
                        <tr v-for="room in rooms" :key="room.Size">
                            <td>{{ room.Size }} m<sup>2</sup></td>
                            <td>{{ room.Volume }} m<sup>3</sup></td>
                            <td><span v-if="room.HasCampaign"
                                    class="room-price-table__campaign-price">({{ getFormattedNumberString(room.CampaignPrice) }} kr)</span> {{
                                        getFormattedNumberString(room.Price)
                                    }} kr./md.</td>
                        </tr>
                    </table>
                    <p class="room-price-table__campaign-price" v-if="rooms != null && rooms.some(x => x.HasCampaign)">
                        {{ dictionary.PriceFinderRoomTablePriceDisclaimer }}</p>
                    <div class="room-price-table__department-link">
                        <a :href="selectedDepartment.Url">{{
                            dictionary.PriceFinderDepartmetLink
                        }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

const locationHelpers = require('./locationHelpers.js');
import RoomSizeSlider from './components/roomSizeSlider.vue';
import LocationSearch from "./locationSearch.vue";
import DepartmentCard from "./components/departmentCard.vue";
import RoomPriceTable from "./components/roomPriceTable.vue";
const serviceUrl = "/umbraco/api/departmentsapi/";
export default {
    name: "priceFinder",
    components: {
        LocationSearch,
        DepartmentCard,
        RoomPriceTable,
        RoomSizeSlider
    },
    data() {
        return {
            dictionary: [],
            departments: [],
            pageSize: 6,
            totalDepartments: 0,
            currentPage: 0,
            size: 0,
            currentSize: 0,
            searchValue: null,
            isLoading: false,
            location: null,
            locationAllowed: false,
            departmentCardDictionary: [],
            selectedDepartment: null,
            rooms: null,
        };
    },
    created() {
        const vm = this;

        fetch("/umbraco/api/dictionaryapi/GetPriceFinderDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                vm.locationAllowed = true;
                locationHelpers.getCityNameFromLocation(position.coords.latitude,
                    position.coords.longitude,
                    function (cityName) {
                        vm.location = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                            city: cityName
                        };
                        vm.locationAllowed = true;
                        vm.getDepartments();
                    });
            });
        }
    },
    mounted() {
        const vm = this;

    },
    methods: {
        handleLocationSearchApiSubmitEvent(location) {
            this.location = location;
            this.getDepartments();
        },
        getDepartments() {
            const vm = this;
            vm.toggleSpinner(true);
            fetch(serviceUrl + 'getDepartments?' + new URLSearchParams({
                lat: vm.location.latitude,
                lng: vm.location.longitude,
                city: vm.location.city,
                take: vm.pageSize,
                skip: vm.pageSize * vm.currentPage
            }))
                .then(response => response.json())
                .then((data) => {
                    if (data.Departments != null) {
                        vm.totalDepartments = data.TotalRecords;
                        if (vm.currentPage == 0) {
                            vm.departments = data.Departments;
                        } else {
                            vm.departments.push(...data.Departments);
                        }
                        vm.departmentCardDictionary = data.Dictionary
                    }
                    vm.toggleSpinner(false);

                })
                .catch(error => {
                    vm.departments = [];
                    vm.toggleSpinner(false);
                })
        },
        getNextPage() {
            if (!this.isLoading) {
                this.currentPage++;
                this.getDepartments();
            }
        },
        handleRangeSlideChange(rooms) {
            this.rooms = rooms.map(group => { return group[0] });
        },
        handleDepartmentSelect(departmentId) {
            this.selectedDepartment = this.departments.find(x => x.Id == departmentId);
            this.size = 0;
            this.rooms = null;
            this.scrollToRooms();
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
        scrollToRooms: function () {
            const isSmallScreen = window.matchMedia('(max-width: 768px)');
            let componentTop = document.querySelector('.room-price-table__wrap').offsetTop;
            if (isSmallScreen.matches) {
                componentTop -= 80;
            } else {
                componentTop -= 249;
            }

            window.scrollTo({
                top: componentTop,
                behavior: 'smooth',
            });
            
            // $('.room-price-table').offset().top - ($('header').height() + 50)

            // $('html, body').animate({
            //     scrollTop: $('.room-price-table').offset().top - ($('header').height() + 50)
            // }, 800)
        },
        getFormattedNumberString(value) {
            if (typeof value == 'undefined') return value;

            if (typeof value == 'string') {
                return parseFloat(value).toLocaleString('da-DK', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            }

            return value.toLocaleString('da-DK', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
    }
};
</script>
